<template>
    <div class="bg-container page">
		<div class="dong_box"><div class="dong_i"></div></div>
        <div class="bg-wrapper">
            <div class="login">
                <van-nav-bar class="nav-bar">
          
                    <template #right>
                        <van-icon name="/img/lang.png" color="#fff" size="30px" @click="showLangSheet = true" />
                    </template>
                </van-nav-bar>
                <div class="wrapper">
                    <div class="logo-container">
                        <div class="logo-wrapper">
                            <img class="logo-img" src="/img/logo.png">
                        </div>
                    </div>
                    <div class="title">{{ $t('page.login.title') }}</div>
                    <div class="loginForm">
                        <van-field v-model="username" clearable input-align="center" class="input" :placeholder="$t('page.login.usernamePlaceholder')" />
                        <van-field v-model="password"
                                   :type="passwordType"
                                   input-align="center"
                                   class="input"
                                   :placeholder="$t('page.login.passwordPlaceholder')">
                            <template slot="right-icon">
                                <van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" @click="switchPasswordType" />
                            </template>
                        </van-field>
                        <div class="reset-text">
                            <span>{{ $t('page.login.forgotPassword') }}</span>
                        </div>
                        <div @click="toRegister()" class="register-text">
                            <span>{{ $t('page.login.registerPrompt') }}</span>
                        </div>
                        <van-button color="linear-gradient(135deg, #8e44ad, #3498db)"  class="login-btn" type="primary" size="normal" @click="doLogin()">{{ $t('page.login.loginBtn') }}</van-button>
                    </div>
                </div>
            </div>
        </div>
        		<van-popup v-model="showLangSheet" position="bottom" round :style="{ height: '50%' }">
        			<div class="popupbox">
        				<div class="title">
        				    <van-icon @click="showLangSheet=false" name="cross" />
        				    <div class="text">{{ $t('page.setting.language') }}</div>
        				    <div class="btnok" > </div>
        					
        				</div>
        				<div class="content">
        					<div class="contentitem"
        						 v-for="(item,index) in langActions" :key="index"
        						 @click="onSelectLang( item )"
        					 > 
        						<div>{{item.name}}</div>
        					</div>
        				</div>
        			</div>
        		</van-popup>
    </div>
</template>

<script>
    import { setLang, LANG_OPTIONS } from '@/locales'
    export default {
        model: {
            prop: 'inputValue',
            event: 'input'
        },
        props: {
            /**
             * Giá trị hiện tại của trường nhập
             */
            inputValue: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                username: '',
                password: this.inputValue,
                passwordType: 'password',
                showLangSheet: false,
                langActions: LANG_OPTIONS,
            };
        },
        methods: {
            switchPasswordType() {
                this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
            },
            back() {
                return window.history.back();
            },
            toRegister() {
                this.$router.push("Register")
            },
            doLogin() {
                if (this.username === "" || this.username === null || this.username === undefined) {
                    this.$toast(this.$t('page.login.enterUsername'));
                    return false;
                }
                if (this.password === "" || this.password === null || this.password === undefined) {
                    this.$toast(this.$t('page.login.enterPassword'));
                    return false;
                }
                this.$http({
                    method: 'get',
                    data: { username: this.username, password: this.password },
                    url: 'member_login'
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success(res.msg);
                        localStorage.setItem('token', res.data.id)
                        this.$router.push("Mine")
                    } else {
                        this.$toast(res.msg);
                    }
                })
            },
            onSelectLang(item) {
                setLang(item.lang);
                this.showLangSheet = false;
                // setTimeout(() => location.reload(), 200);
            }
        },
        created() {
            if (localStorage.getItem('token')) {
                return window.history.back();
            }
        }
    };
</script>

<style lang='less' scoped>
    @import "../../assets/css/base.css";

    .login {
        height: 100%;
    }

    .bg-container .bg-wrapper .login .nav-bar {
        background: 0 0
    }

    .login .wrapper {
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    .logo-container {
        margin: 0 auto;
        width: 45%;
    }

        .logo-container .logo-wrapper {
            position: relative;
            padding-bottom: 62.5%;
        }

            .logo-container .logo-wrapper .logo-img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                -o-object-fit: contain;
                object-fit: contain;
            }

    .login .wrapper .title {
        line-height: 100px;
        text-align: center;
        font-size: 45px;
        font-weight: 700;
        color: #fff;
        letter-spacing: 5px;
    }

    .login .wrapper .loginForm {
        padding: 60px;
    }

        .login .wrapper .loginForm .input {
            padding: 10px 20px;
            margin-top: 40px;
            border-radius: 50px;
            text-align: center;
            line-height: 80px;
            font-size: 30px;
            color: #4e4e4e;
        }

    ::v-deep .van-field__right-icon .van-icon {
        font-size: 50px;
    }

    ::v-deep .van-icon {
        font-size: 50px;
    }

    .login .wrapper .loginForm .reset-text {
        margin: 30px 15px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

        .login .wrapper .loginForm .reset-text span {
            color: #fff;
            font-size: 25px;
            font-weight: 500;
            line-height: 15px;
        }

    .login .wrapper .loginForm .register-text {
        margin: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

        .login .wrapper .loginForm .register-text span {
            color: #fff;
            font-size: 25px;
            font-weight: 500;
            line-height: 20px;
        }

    .login .wrapper .loginForm .active {
    }

    .login .wrapper .loginForm .login-btn {
        margin-top: 85px;
        width: 100%;
        height: 100px;
        border-radius: 50px;
        color: #fff;
        background-color: #267bdb;
        font-size: 30px;
        font-weight: bolder;
        border: none;
    }
	
	
	
</style>
